export const useContext = () => {
  // Create a cached store using useState
  const cachedOrg = useState<Organisation | null>('organisation', () => null)
  const domainb64 = useState<string>('domainb64', () => '')
  const urlBase = useState<string>('urlBase', () => '')

  const fetchContext = async () => {
    // Return cached data if available
    if (cachedOrg.value) {
      return {
        org: cachedOrg.value as Organisation,
        domainb64: domainb64.value,
        urlBase: urlBase.value,
      }
    }

    const nuxt = useNuxtApp()
    const url = useRequestURL()
    const route = nuxt._route
    const season = route.params.season ?? null

    // Get domain
    let domain = ''
    try {
      domain = new URL(url.href).hostname
      if (domain === 'localhost') {
        domain = nuxt.ssrContext?.event.context.org_domain
      }
    }
    catch {
      domain = nuxt.ssrContext?.event.context.org_domain
    }

    // Encode domain and store it
    domainb64.value = btoa(domain)

    let data = null

    // Fetch data
    if (season && season !== undefined) {
      data = await fetch(
        `${nuxt.$config.public.api_base_url}/competition/${domainb64.value}?season=${season}`,
      )
    }
    else {
      data = await fetch(
        `${nuxt.$config.public.api_base_url}/competition/${domainb64.value}?season=`,
      )
    }

    // Cache the result
    cachedOrg.value = await data.json()

    return {
      org: cachedOrg.value as Organisation,
      domainb64: domainb64.value,
      urlBase: urlBase.value,
    }
  }

  return {
    org: cachedOrg.value!,
    urlBase: urlBase.value!,
    fetchContext,
  }
}
